import { Box } from '@gassan-ui'
import React, { FC, PropsWithChildren } from 'react'
import { GridColumnProps, MarginBottomProps, MarginTopProps } from 'styled-system'
import { Span } from '../Typography'
import { Label } from './Label'
import { Error } from './styles'

export type FieldControlProps = PropsWithChildren<
  MarginBottomProps &
    MarginTopProps &
    GridColumnProps & {
      label?: React.ReactNode | string
      assistiveText?: string
      errorMsg?: string
      isCheckbox?: boolean
    }
>

export const FieldControl: FC<FieldControlProps> = ({
  label,
  assistiveText,
  errorMsg,
  children,
  isCheckbox = false,
  mb = '1.5rem',
  ...rest
}) => {
  return (
    <Box {...rest} position="relative" mb={mb} pt="3">
      {children}
      {label ? typeof label === 'string' && <Label>{label}</Label> : label}
      {assistiveText ? (
        <Span display="block" fontSize=".75rem" mt={2} color="shades.500">
          {assistiveText}
        </Span>
      ) : errorMsg ? (
        <Error errorOnTop={isCheckbox}>{errorMsg}</Error>
      ) : null}
    </Box>
  )
}
